import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import UIButton from 'UIComponents/button/UIButton';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const GenericFeedbackOptions = ['incorrectAction', 'notRelevant', 'incomplete', 'inaccurate', 'other'];
const FeedbackButtons = ({
  selectedOptions,
  onOptionSelect
}) => {
  return /*#__PURE__*/_jsx(_Fragment, {
    children: GenericFeedbackOptions.map(option => {
      if (isNaN(Number(option))) {
        return /*#__PURE__*/_jsx(UIButton, {
          "data-test-id": "feedback-button",
          size: "xs",
          use: selectedOptions.includes(option) ? 'tertiary-light' : 'tertiary-extra-light',
          responsive: true,
          onClick: () => onOptionSelect(option),
          children: /*#__PURE__*/_jsx(FormattedReactMessage, {
            message: `aiComponentsUiLibrary.components.inlineFeedback.messageFeedback.options.${option}`
          })
        }, option);
      }
      return null;
    })
  });
};
export default FeedbackButtons;